import Vue from "vue";
import Router from "vue-router";

import Admin from "../containers/Admin.vue";
import Default from "../containers/Default.vue";

import Login from "../views/pages/Login.vue";
import Logout from "../views/pages/Logout.vue";
import PasswordReset from "../views/pages/PasswordReset.vue";
import Error403View from "../views/errors/Error403View.vue";
import Error404View from "../views/errors/Error404View.vue";
import ErrorGeneralView from "../views/errors/ErrorGeneralView.vue";
import BrandList from "../views/brands/List.vue";
import BrandEdit from "../views/brands/Edit.vue";
import BrandXeroAccept from "../views/brands/XeroAccept.vue";
import TechnicianList from "../views/users/List.vue";
import TechnicianEdit from "../views/users/Edit.vue";
import UserExportLog from "../views/users/ExportLog.vue";
import CustomerList from "../views/customers/List.vue";
import CustomerEdit from "../views/customers/Edit.vue";
import AcceptQuote from "../views/invoices/AcceptQuote.vue";
import PayInvoice from "../views/invoices/Pay.vue";
import InvoiceList from "../views/invoices/List.vue";
import InvoiceEdit from "../views/invoices/Edit.vue";
import ReminderList from "../views/reminders/List.vue";
import ReminderEdit from "../views/reminders/Edit.vue";
import JobDispatch from "../views/jobs/Dispatch.vue";
import JobNoAccess from "../views/jobs/NoAccess.vue";
import JobExportLog from "../views/jobs/ExportLog.vue";
import AcceptedQuoteList from "../views/invoices/AcceptedQuoteList.vue";
import MediaList from "../views/media/List.vue";
import VoucherList from "../views/vouchers/List.vue";
import VoucherEdit from "../views/vouchers/Edit.vue";
import DesignationChart from "../views/designations/Chart.vue";
import DesignationList from "../views/designations/List.vue";
import DesignationEdit from "../views/designations/Edit.vue";
import TributeList from "../views/tributes/List.vue";
import TributeEdit from "../views/tributes/Edit.vue";
import PublicHolidayList from "../views/public-holidays/List.vue";
import PublicHolidayEdit from "../views/public-holidays/Edit.vue";
import PublicHolidayUpload from "../views/public-holidays/Upload.vue";

Vue.use(Router);

const routes = [
  {
    path: "/",
    name: "Home",
    redirect: "/jobs",
    component: Admin,
    children: [
      {
        path: "jobs",
        name: "jobs",
        component: Default,
        meta: {
          auth: true,
        },
        children: [
          {
            path: "",
            name: "jobs.dispatch",
            component: JobDispatch,
            meta: {
              title: "",
            },
          },
          {
            path: ":id/logs",
            name: "job.logs",
            component: JobExportLog,
            meta: {
              title: "Export Job Logs",
            },
          },
          {
            path: ":id/edit",
            name: "jobs.edit",
            component: JobDispatch,
            meta: {
              title: "Job",
            },
          },
          {
            path: "no-access",
            name: "jobs.no-access",
            component: JobNoAccess,
            meta: {
              title: "Job",
            },
          },
        ],
      },

      {
        path: "customers",
        redirect: "/customers/list",
        name: "customers",
        component: Default,
        children: [
          {
            path: "list",
            name: "customers.list",
            component: CustomerList,
            meta: {
              title: "Customer List",
            },
          },
          {
            path: "create",
            name: "customers.create",
            component: CustomerEdit,
            meta: {
              title: "Customer Create",
            },
          },
          {
            path: ":id/edit",
            name: "customers.edit",
            component: CustomerEdit,
            meta: {
              title: "Customer",
            },
          },
        ],
      },

      {
        path: "invoices",
        redirect: "/invoices/list",
        name: "invoices",
        component: Default,
        meta: {
          auth: true,
        },
        children: [
          {
            path: "list",
            name: "invoices.list",
            component: InvoiceList,
            meta: {
              title: "Invoice List",
            },
          },
          {
            path: "accepted-quote-list",
            name: "accepted-quotes.list",
            component: AcceptedQuoteList,
            meta: {
              title: "Accepted Quote List",
            },
          },
          {
            path: "create/job-id/:jobId",
            name: "invoices.create",
            component: InvoiceEdit,
            meta: {
              title: "Invoice Create",
            },
          },
          {
            path: ":id/edit",
            name: "invoices.edit",
            component: InvoiceEdit,
            meta: {
              title: "Invoice",
            },
          },
        ],
      },

      {
        path: "users",
        redirect: "/users/list",
        name: "users",
        component: Default,
        children: [
          {
            path: "list",
            name: "users.list",
            component: TechnicianList,
            meta: {
              title: "User List",
            },
          },
          {
            path: "create",
            name: "users.create",
            component: TechnicianEdit,
            meta: {
              title: "User Create",
            },
          },
          {
            path: ":id/edit",
            name: "users.edit",
            component: TechnicianEdit,
            meta: {
              title: "User",
            },
          },
          {
            path: ":id/logs",
            name: "users.logs",
            component: UserExportLog,
            meta: {
              title: "Export Technician Logs",
            },
          },
        ],
      },

      {
        path: "brands",
        redirect: "/brands/list",
        name: "brands",
        component: Default,
        meta: {
          auth: {
            roles: ["superadmin", "admin", "manager"],
          },
        },
        children: [
          {
            path: "list",
            name: "brands.list",
            component: BrandList,
            meta: {
              title: "Brand List",
            },
          },
          {
            path: "create",
            name: "brands.create",
            component: BrandEdit,
            meta: {
              title: "Brand Create",
            },
          },
          {
            path: ":id/edit",
            name: "brands.edit",
            component: BrandEdit,
            meta: {
              title: "Brand",
            },
          },
        ],
      },

      {
        path: "reminders",
        redirect: "/reminders/list",
        name: "reminders",
        component: Default,
        meta: {
          auth: {
            roles: ["superadmin", "admin", "manager"],
          },
        },
        children: [
          {
            path: "list",
            name: "reminders.list",
            component: ReminderList,
            meta: {
              title: "Reminder List",
            },
          },
          {
            path: "create",
            name: "reminders.create",
            component: ReminderEdit,
            meta: {
              title: "Reminder Create",
            },
          },
          {
            path: ":id/edit",
            name: "reminders.edit",
            component: ReminderEdit,
            meta: {
              title: "Reminder",
            },
          },
        ],
      },

      {
        path: "media",
        redirect: "/media/list",
        name: "media",
        component: Default,
        children: [
          {
            path: "list",
            name: "media.list",
            component: MediaList,
            meta: {
              title: "Media List",
            },
          },
        ],
      },

      {
        path: "vouchers",
        redirect: "/vouchers/list",
        name: "vouchers",
        component: Default,
        meta: {
          auth: {
            roles: ["superadmin", "admin"],
          },
        },
        children: [
          {
            path: "list",
            name: "vouchers.list",
            component: VoucherList,
            meta: {
              title: "Voucher List",
            },
          },
          {
            path: "create",
            name: "vouchers.create",
            component: VoucherEdit,
            meta: {
              title: "Voucher Create",
            },
          },
          {
            path: ":id/edit",
            name: "vouchers.edit",
            component: VoucherEdit,
            meta: {
              title: "Voucher",
            },
          },
        ],
      },

      {
        path: "designations",
        redirect: "/designations/chart",
        name: "designations",
        component: Default,
        meta: {
          auth: {
            roles: ["superadmin", "admin"],
          },
        },
        children: [
          {
            path: "chart",
            name: "designations.chart",
            component: DesignationChart,
            meta: {
              title: "Designation Chart",
            },
          },
          {
            path: "list",
            name: "designations.list",
            component: DesignationList,
            meta: {
              title: "Designation List",
            },
          },
          {
            path: "create",
            name: "designations.create",
            component: DesignationEdit,
            meta: {
              title: "Designation Create",
            },
          },
          {
            path: ":id/edit",
            name: "designations.edit",
            component: DesignationEdit,
            meta: {
              title: "Designation",
            },
          },
        ],
      },

      {
        path: "public-holidays",
        redirect: "/public-holidays/list",
        name: "public holidays",
        component: Default,
        meta: {
          auth: {
            roles: ["superadmin", "admin"],
          },
        },
        children: [
          {
            path: "list",
            name: "public-holidays.list",
            component: PublicHolidayList,
            meta: {
              title: "Public Holidays List",
            },
          },
          {
            path: "create",
            name: "public-holidays.create",
            component: PublicHolidayEdit,
            meta: {
              title: "Public Holiday Create",
            },
          },
          {
            path: "upload",
            name: "public-holidays.upload",
            component: PublicHolidayUpload,
            meta: {
              title: "Public Holiday Upload",
            },
          },
          {
            path: ":id/edit",
            name: "public-holidays.edit",
            component: PublicHolidayEdit,
            meta: {
              title: "Public Holiday",
            },
          },
        ],
      },

      {
        path: "tributes",
        redirect: "/tributes/list",
        name: "tributes",
        component: Default,
        meta: {
          auth: {
            roles: ["superadmin", "admin"],
          },
        },
        children: [
          {
            path: "list",
            name: "tributes.list",
            component: TributeList,
            meta: {
              title: "Tribute List",
            },
          },
          {
            path: "create",
            name: "tributes.create",
            component: TributeEdit,
            meta: {
              title: "Tribute Create",
            },
          },
          {
            path: ":id/edit",
            name: "tributes.edit",
            component: TributeEdit,
            meta: {
              title: "Tribute",
            },
          },
        ],
      },
    ],
  },

  {
    path: "/",
    name: "Pages",
    component: Default,
    children: [
      {
        path: "login",
        name: "login",
        component: Login,
        meta: {
          title: "Login",
        },
      },
      {
        path: "logout",
        name: "logout",
        component: Logout,
        meta: {
          title: "Logout",
        },
      },
      {
        path: "password/reset",
        name: "password-reset",
        component: PasswordReset,
        meta: {
          title: "Password Reset",
        },
      },

      {
        path: "invoices/:uuid/pay",
        name: "invoices.pay",
        component: PayInvoice,
        meta: {
          title: "Pay Invoice",
        },
      },
      {
        path: "invoices/:uuid/accept-quote",
        name: "invoices.accept",
        component: AcceptQuote,
        meta: {
          title: "Accept Quote",
        },
      },
      {
        path: "brands/xero-accept",
        name: "brands.xero-accept",
        component: BrandXeroAccept,
        meta: {
          auth: {
            roles: ["superadmin", "admin"],
          },
          title: "Brand Xero Accept",
        },
      },
    ],
  },

  {
    path: "/error",
    name: "Errors",
    component: Default,
    children: [
      {
        path: "general",
        name: "error.general",
        component: ErrorGeneralView,
        meta: {
          title: "Error",
        },
      },
      {
        path: "403",
        name: "error.403",
        component: Error403View,
        meta: {
          title: "Error",
        },
      },
      {
        path: "404",
        name: "error.404",
        component: Error404View,
        meta: {
          title: "Error",
        },
      },
    ],
  },
];

// noinspection JSCheckFunctionSignatures
Vue.router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  linkActiveClass: "open active",
  scrollBehavior: () => ({ y: 0 }),
  routes,
});

Vue.router.afterEach((to, from) => {
  if (from?.name === "jobs.edit" && to?.name !== "jobs.edit" && to?.name !== "jobs.dispatch") {
    window.toastr.remove();
  }

  document.body.classList.remove("sidebar-lg-show");

  let title = to.meta.title || "";
  document.title = title
    .replace(".", " ")
    .toLowerCase()
    .replace(/ \S|^./g, (a) => a.toUpperCase());
});

export default Vue.router;
